const fileMap = new Map([
  ['text', '文本'],
  ['file', '文件'],
  ['image', '图片'],
  ['video', '视频'],
  ['link', '链接'],
  ['chatrecord', '会话消息记录'],
  ['docmsg', '在线文档消息'],
  ['markdown', 'MarkDown格式消息'],
  ['card', '名片'],
  ['location', '位置'],
  ['external_redpacket', '红包消息'],
  ['redpacket', '红包消息'],
  ['mixed', '混合消息'],
  ['revoke', '撤回消息'],
  ['agree', '同意会话聊天内容'],
  ['disagree', '不同意会话聊天内容'],
  ['voice', '语音'],
  ['emotion', '自定义表情'],
  ['weapp', '小程序'],
  ['todo', '待办消息'],
  ['vote', '投票消息'],
  ['collect', '填表消息'],
  ['meeting', '会议邀请消息'],
  ['news', '图文消息'],
  ['calendar', '日程消息'],
  ['meeting_voice_call', '音频存档消息'],
  ['voip_doc_share', '音频共享文档消息'],
  ['external_redpacket', '互通红包消息'],
])

export default fileMap
